import { render, staticRenderFns } from "./StatusEditor.vue?vue&type=template&id=37ce3e4a&scoped=true&"
import script from "./StatusEditor.vue?vue&type=script&lang=js&"
export * from "./StatusEditor.vue?vue&type=script&lang=js&"
import style0 from "./StatusEditor.vue?vue&type=style&index=0&id=37ce3e4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ce3e4a",
  null
  
)

export default component.exports